module.exports = __webpack_public_path__ + "img/left.97142e56.png";